import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const MySwal = withReactContent(Swal);

// Base styles that are common across all alert types
const baseStyles = {
  background: 'rgba(255, 255, 255, 0.98)',
  backdrop: `
    rgba(0,0,0,0.5)
    left top
    no-repeat
  `,
  customClass: {
    popup: 'animated fadeInDown swal2-popup-custom',
    htmlContainer: 'swal2-html-container swal2-html-custom swal2-content-normal-weight',
    footer: 'swal2-footer-custom',
    content: 'swal2-content-normal-weight'
  },
  showClass: {
    popup: 'animate__animated animate__fadeInDown animate__faster'
  },
  hideClass: {
    popup: 'animate__animated animate__fadeOutUp animate__faster'
  },
  buttonsStyling: true,
  reverseButtons: true,
  padding: '2.5em',
  borderRadius: '20px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
  width: 'auto',
  position: 'center',
  grow: 'row',
  customStyle: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif"
  }
};

// Success alert configuration
export const successConfig = {
  ...baseStyles,
  icon: 'success',
  title: 'Success!',
  confirmButtonColor: '#28a745',
  customClass: {
    ...baseStyles.customClass,
    title: 'text-success swal2-title-custom',
    confirmButton: 'btn btn-success swal2-confirm-button',
    icon: 'swal2-icon-success swal2-icon-custom',
    content: 'swal2-content-normal-weight'
  },
  timer: 5000,
  timerProgressBar: true,
  showConfirmButton: false
};

// Error alert configuration
export const errorConfig = {
  ...baseStyles,
  icon: 'error',
  confirmButtonColor: '#dc3545',
  customClass: {
    ...baseStyles.customClass,
    title: 'text-danger swal2-title-custom',
    confirmButton: 'btn btn-danger swal2-confirm-button',
    icon: 'swal2-icon-error swal2-icon-custom',
    content: 'swal2-content-normal-weight'
  }
};

// Warning alert configuration
export const warningConfig = {
  ...baseStyles,
  icon: 'warning',
  confirmButtonColor: '#ffc107',
  customClass: {
    ...baseStyles.customClass,
    title: 'text-warning swal2-title-custom',
    confirmButton: 'btn btn-warning swal2-confirm-button',
    icon: 'swal2-icon-warning swal2-icon-custom',
    content: 'swal2-content-normal-weight'
  }
};

// Info alert configuration
export const infoConfig = {
  ...baseStyles,
  icon: 'info',
  confirmButtonColor: '#17a2b8',
  customClass: {
    ...baseStyles.customClass,
    title: 'text-info swal2-title-custom',
    confirmButton: 'btn btn-info swal2-confirm-button',
    icon: 'swal2-icon-info swal2-icon-custom',
    content: 'swal2-content-normal-weight'
  }
};

// Question alert configuration
export const questionConfig = {
  ...baseStyles,
  icon: 'question',
  confirmButtonColor: '#6c757d',
  customClass: {
    ...baseStyles.customClass,
    title: 'text-secondary swal2-title-custom',
    confirmButton: 'btn btn-secondary swal2-confirm-button',
    icon: 'swal2-icon-question swal2-icon-custom',
    content: 'swal2-content-normal-weight'
  }
};

// Helper functions for common alert types
export const showSuccessAlert = (message, title = 'Success!') => {
  return MySwal.fire({
    ...successConfig,
    title,
    text: message
  });
};

export const showErrorAlert = (message, title = 'Error!') => {
  return MySwal.fire({
    ...errorConfig,
    title,
    text: message
  });
};

export const showWarningAlert = (message, title = 'Warning!') => {
  return MySwal.fire({
    ...warningConfig,
    title,
    text: message
  });
};

export const showInfoAlert = (message, title = 'Information') => {
  return MySwal.fire({
    ...infoConfig,
    title,
    text: message
  });
};

export const showConfirmDialog = (message, title = 'Are you sure?') => {
  return MySwal.fire({
    ...questionConfig,
    title,
    text: message,
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  });
}; 